module.exports = __webpack_public_path__ + "img/qywhbj@2X.f228fb36.png";